import { useContext } from 'react'

import AuthContext, { UserProfile } from '@/contexts/Auth/AuthContext'

const PERMITTED_EMAILS = [
  'lpassos@avantstay.com',
  'aferreira@avantstay.com',
  'atarchetti@avantstay.com',
  'dev@avantstay.com',
  'eilgaz@avantstay.com',
  'ibrilhante@avantstay.com',
  'jamorim@avantstay.com',
  'jmachado@avantstay.com',
  'rmoral@avantstay.com',
  'vferrara@avantstay.com',
  'vfranca@avantstay.com',
  'bchagas@avantstay.com',
  'ctimmons@avantstay.com',
  'tprzysiwek@avantstay.com',
]

const MARKET_MANAGER_EMAILS = [
  'aferreira@avantstay.com',
  'bchagas@avantstay.com',
  'eilgaz@avantstay.com',
  'fendo@avantstay.com',
  'ibrilhante@avantstay.com',
  'jamorim@avantstay.com',
  'jmachado@avantstay.com',
  'lnguyen@avantstay.com',
  'lpassos@avantstay.com',
  'mbandara@avantstay.com',
  'rmoral@avantstay.com',
  // Emails for Executive team
  'sean@avantstay.com',
  'sbreuner@avantstay.com',
  'seanb@avantstay.com',
  'tprzysiwek@avantstay.com',
]

const QA_TESTER_EMAILS = [
  'apatseev@avantstay.com',
  'eilgaz@avantstay.com',
  'ibrilhante@avantstay.com',
  'jamorim@avantstay.com',
  'jmachado@avantstay.com',
  'lnguyen@avantstay.com',
  'lpassos@avantstay.com',
  'vfranca@avantstay.com',
  'tprzysiwek@avantstay.com',
]

export const usePricingToolPermission = (): boolean => {
  const auth = useContext(AuthContext)

  const user = auth.user as UserProfile
  return (
    PERMITTED_EMAILS.includes(user?.email) ||
    Boolean(user?.roles?.some(role => role.name === 'Revenue Management'))
  )
}

export const usePricingToolManagerPermission = (): boolean => {
  const auth = useContext(AuthContext)
  const user = auth.user as UserProfile
  return MARKET_MANAGER_EMAILS.includes(user?.email)
}

export const usePricingToolTesterPermission = (): boolean => {
  const auth = useContext(AuthContext)
  const user = auth.user as UserProfile
  return QA_TESTER_EMAILS.includes(user?.email)
}

export const useCurrentUserAccessingPricingTool = (): string => {
  const auth = useContext(AuthContext)
  const user = auth.user as UserProfile

  return user?.email
}

export const useCurrentUser = (): UserProfile => {
  const auth = useContext(AuthContext)
  const user = auth.user as UserProfile
  return user
}
